// ABOUTME: Triangle-cloud icon, ported from the Ohana Dashboard mockup — used on the
// ABOUTME: "Triangles" stat tile and, under the nalu-v1 theme, the Triangle tally button
// ABOUTME: Inline SVG (no standalone asset file exists for this icon in the design handoff)

import React from 'react';
import { useTheme } from '@mui/material/styles';

interface TriangleCloudIconProps {
  size?: number;
  /** True when embedded in an already-labeled control (e.g. a button with its own aria-label) — omits the SVG's own role/aria-label to avoid a redundant nested accessible name. */
  decorative?: boolean;
}

export const TriangleCloudIcon: React.FC<TriangleCloudIconProps> = ({ size = 54, decorative = false }) => {
  const theme = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 54 54"
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Triangle' })}
    >
      <rect width="54" height="54" rx="14" fill={theme.palette.background.paper} />
      <ellipse cx="17" cy="18" rx="11" ry="8" fill={theme.palette.warning.light} />
      <ellipse cx="29" cy="13" rx="11" ry="8.5" fill={theme.palette.warning.light} />
      <ellipse cx="39" cy="19" rx="9" ry="7" fill={theme.palette.warning.light} />
      <path d="M30 18 L42.1 39 H17.9 Z" fill={theme.palette.warning.main} stroke={theme.palette.warning.main} strokeWidth="4" strokeLinejoin="round" />
      <rect x="29" y="25" width="2.2" height="7" rx="1.1" fill={theme.palette.background.default} />
      <circle cx="30" cy="36" r="1.4" fill={theme.palette.background.default} />
    </svg>
  );
};
